import React from 'react';
import FlatButton from 'material-ui/FlatButton';
import IconButton from 'material-ui/IconButton';
import DeleteIcon from 'images/common/DeleteRemove.svg';
import SavedSearchActions from 'actions/search/SavedSearchActions';

const savedSearchButtonStyle = {
  minWidth: 'initial',
  height: 'inherit',
  lineHeight: 'inherit',
  flex: '1 1 0%',
  textAlign: 'left',
};

const savedSearchDeleteButtonStyle = {
  height: '18px',
  width: '18px',
  padding: '0',
  display: 'none',
};

const savedSearchButtonLabelStyle = {
  marginLeft: '0px',
  minWidth: 'initial',
  textAlign: 'left',
  paddingLeft: '0px',
  textTransform: 'none',
  fontSize: 'inherit',
};

/**
 * A `SavedSearchFlatButton` renders a saved_search.title as a flat button that
 * looks like a hyberlink
 */
class SavedSearchFlatButton extends React.Component {
  onTouchTapDeleteSavedSearchButton = () => {
    this.props.SavedSearchActions.deleteSavedSearch(this.props.savedSearch);
  };

  /**
   * Depending on whether the user is "in" an active search or not, we perform different actions:
   *
   * 1. If the user is "in" an active search, then we perform the clicked active saved search using
   * its `data` object which contains term, fields, limit and page, and then update the search results
   * as well as the search sidebar accordingly
   *
   * 2. If the user is not "in" an active search, then we perform the clicked saved search using
   * its `data` object, update the search results and the search sidebar and put the user "in"
   * the said active saved search
   *
   */
  onTouchTapSavedSearchLinkButton = () => {
    if (this.props.isInSearchMode) {
      // Perform the clicked active saved search and update the search results and sidebar
    } else {
      // Perform the clicked saved search, update the search results and sidebar, and put the user
      // into the said active saved search
      SavedSearchActions.executeInactiveSearch(this.props.savedSearch);
    }
  };

  render() {
    return (
      <div className="saved-search">
        <FlatButton
          label={this.props.savedSearch.title}
          className="saved-search-flat-button"
          style={savedSearchButtonStyle}
          labelStyle={savedSearchButtonLabelStyle}
          hoverColor="initial"
          onClick={this.onTouchTapSavedSearchLinkButton}
        />
        <IconButton
          className="saved-search-delete-button"
          style={savedSearchDeleteButtonStyle}
          onClick={this.onTouchTapDeleteSavedSearchButton}>
          <img alt="unknown" src={DeleteIcon} />
        </IconButton>
      </div>
    );
  }
}

export default SavedSearchFlatButton;
